import React, { useEffect, useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";
import {
  GetCirclebyID,
  GetWardsbyCircleId,
  GetZone,
  GetVehicleType
} from "../../Apis/organizationApi";
import { AllShiftMaster } from "../../Apis/shiftMasterApi";
import { GetRoute } from "../../Apis/routeMasterApi";
import { AllOwnerTypeDetails } from "../../Apis/ownerTypeApi";
import { GetSCVCountDashboard } from "../../Apis/DashboardApis/ScvsDashbaordApi";
import Loader from "../../Common/Loader/loader";
import isGHMC from "../../Common/helper/helpar";
import Select from "react-select";
const ScvsDashboard = () => {
  const isProd = isGHMC();
  const [gvpCountDashboard, setGVPCountDashboard] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [allZones, setAllZones] = useState([]);
  const [allCircles, setAllCircles] = useState([]);
  const [selectedZone, setSelectedZone] = useState(null);
  const [selectedCircles, setSelectedCircles] = useState(null);
  const [loadingCircles, setLoadingCircles] = useState(false);
  const [circles, setCircles] = useState([]);
  const [selectedShift, setSelectedShift] = useState(null);
  const [shiftData, setShiftData] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [routeData, setRouteData] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [ownerData, setOwnerData] = useState([]);
  const [allWards, setAllWards] = useState([]);
  const [selectedWard, setSelectedWard] = useState(null);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [selectedVehicleTypes, setSelectedVehicleTypes] = useState([]);


  const fetchAllVehicleTypeData = async () => {
  const vehicleTypesData = await GetVehicleType();
  setVehicleTypeDetails(vehicleTypesData);
};

  const fetchAllDataDetails = async () => {
    try {
      const zonesData = await GetZone();
      setAllZones(zonesData);
      if (selectedZone) {
        const circlesData = await GetCirclebyID(selectedZone);
        setCircles(circlesData);
        setSelectedCircles([]);
        setIsOptionsLoading(false);
      } else {
        setCircles([]);
        setSelectedCircles([]);
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  const fetchShift = async () => {
    try {
      const response = await AllShiftMaster();
      setShiftData(response);
    } catch (error) {
    }
  };

  const fetchRoute = async () => {
    try {
      const response = await GetRoute();
      setRouteData(response.data);
    } catch (error) {
    }
  };

  const fetchOwner = async () => {
    try {
      const response = await AllOwnerTypeDetails();
      setOwnerData(response);
    } catch (error) {
    }
  };

  useEffect(() => {
    fetchAllDataDetails();
    fetchShift();
    fetchRoute();
    fetchOwner();
    fetchAllVehicleTypeData();
  }, []);


  useEffect(() => {
    const fetchZones = async () => {
      try {
        const zonesData = await GetZone();
        setAllZones(zonesData);
      } catch (error) {
        console.error("Error fetching zones data:", error);
      }
    };

    fetchZones();
  }, []);

  useEffect(() => {
    const fetchCirclesByZone = async () => {
      try {
        if (selectedZone) {
          // Fetch circles based on the selected zone ID
          const circlesData = await GetCirclebyID(selectedZone);
          setAllCircles(circlesData);
        } else {
          setAllCircles([]);
        }
      } catch (error) {
        console.error("Error fetching circles data:", error);
      }
    };

    fetchCirclesByZone();
  }, [selectedZone]);

  useEffect(() => {
    const fetchWardsByCircle = async () => {
      try {
        if (selectedCircles) {
          // Fetch wards based on the selected circle ID
          const wardsData = await GetWardsbyCircleId(selectedCircles);
          setAllWards(wardsData); // Assuming wards data is in the format you expect
        } else {
          setAllWards([]); // Reset wards if no circle is selected
        }
      } catch (error) {
        console.error("Error fetching wards data:", error);
      }
    };

    fetchWardsByCircle();
  }, [selectedCircles]);

  const displayNames = {
    activeLE: (
      <>
        Active
        Loading Equipments
      </>
    ),
    activeScv: "Active Primary Vehicles",
    condemed: "InActive Primary Vehicles",
    condemedLE: (
      <>
        InActive Primary Vehicles
        Loading Equipments
      </>
    ),
    deployedScv: "Deployed Primary Vehicles",
    leAssigned: (
      <>
        Assigned
        Loading Equipments
      </>
    ),
    // routesAssigned: "Routes Assigned",
    // routesCompleted: "Routes Completed",
    // routesInProgress: "Routes In Progress",
    totalLE: (
      <>
        Total
        Loading Equipments
      </>
    ),
    // totalRoutes: "Total Routes",
    totalScv: "Total Primary Vehicles",
  };


  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AF19FF'];

  const handleSearch = async () => {
    if (!startDate || !endDate) {
      alert("Please select both From Date and To Date.");
      return;
    }

    try {
      setIsOptionsLoading(true);
  const vehicleTypeIds = selectedVehicleTypes.map(v => v.value);
  console.log("Selected vehicle types:", selectedVehicleTypes);
console.log("VehicleTypeIds string:", vehicleTypeIds.join(","));
      const gvpResponse = await GetSCVCountDashboard(
        startDate,
        endDate,
        selectedZone,
        selectedCircles,
        selectedWard,
        selectedShift,
        selectedRoute,
        selectedOwner,
        vehicleTypeIds.length > 0 ? vehicleTypeIds.join(",") : null 
      );

      const responseData = gvpResponse?.data || [];
      const mergedData = responseData.reduce((acc, curr) => ({ ...acc, ...curr }), {});
      setGVPCountDashboard(mergedData);

      const isEmpty =
        Object.keys(mergedData).length === 0 ||
        Object.values(mergedData).every((val) => val === 0);

      if (!isEmpty) {
        const pieData = Object.keys(mergedData).map((key, index) => ({
          name: key.replace(/([A-Z])/g, " $1").trim().toUpperCase(),
          value: mergedData[key],
          color: COLORS[index % COLORS.length],
        }));
        setChartData(pieData);
      } else {
        setChartData([]);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  useEffect(() => {
    handleSearch()
  }, [])



  return (
    <div style={{ width: "100%" }}>
      <div className="content">
        <div className="page-content">
          <h4 className="text-start mb-3">Primary Deployment Dashboard</h4>
          <div className="card">
            <div className="card-body">


              <div className="row " style={{ textAlign: "justify" }}>
                <div className="col-md-12">
                  <form>
                    <div className="row" style={{ textAlign: "justify" }}>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="startDate">From Date & Time</label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            id="startDate"
                            name="startDate"
                            style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="endDate">To Date & Time</label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            id="endDate"
                            name="endDate"
                            style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                            value={endDate}
                            onChange={(e) => {
                              // Check if end date is before start date
                              if (new Date(e.target.value) < new Date(startDate)) {
                                alert("End date cannot be before start date");
                                return; // Don't update end date if it's invalid
                              }
                              setEndDate(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                          <label htmlFor="VehicleTypeId">Vehicle Type</label>
                          <Select
                              isMulti
                              className="basic-multi-select"
                              classNamePrefix="select"
                              name="vehicleTypes"
                              options={vehicleTypeDetails
                                  .filter((v) => v.isActive)
                                  .map((v) => ({ value: v.vehicleTypeId, label: v.vehicleTypeName }))}
                              value={selectedVehicleTypes}
                              onChange={(selected) => setSelectedVehicleTypes(selected || [])}
                              placeholder="Select Vehicle Types"
                              isClearable
                          />
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="ZoneId">Select Zone</label>
                          <select
                            type="text"
                            name="ZoneId"
                            className="form-select"
                            style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                            value={selectedZone}
                            onChange={(e) => {
                              if (e.target.value === "") {
                                // Clear selected circle and transfer station when "All Zones" is selected
                                setSelectedCircles("");
                              }
                              setSelectedZone(e.target.value);
                            }}
                          >
                            <option value="">All</option>
                            {allZones.filter((zone) => zone.isActive).map((zone) => (
                              <option key={zone.zoneId} value={zone.zoneId}>
                                {zone.zoneName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="CircleId">Select Ward</label>
                          <select
                            type="text"
                            name="CircleId"
                            className="form-select"
                            style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                            value={selectedCircles}
                            onChange={(e) => {
                              const selectedCircleId = e.target.value;
                              setSelectedCircles(selectedCircleId);
                            }}
                          >
                            <option value="">All</option>
                            {allCircles?.map((circle) => (
                              <option
                                key={circle.circleId}
                                value={circle.circleId}
                                selected={circle.circleId === selectedCircles}
                              >
                                {circle.circleName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      {/* <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="WardId">Select Ward</label>
                          <select
                            type="text"
                            name="WardId"
                            className="form-select"
                            style={{ backgroundColor: "#FFF" }}
                            value={selectedWard}
                            onChange={(e) => {
                              setSelectedWard(e.target.value);
                            }}
                          >
                            <option value="">All</option>
                            {allWards.map((ward) => (
                              <option
                                key={ward.wardId}
                                value={ward.wardId}
                                selected={ward.wardId === selectedWard}
                              >
                                {ward.wardName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div> */}
                      <div className="col-md-3 ">
                        <div className="form-group">
                          <label className="form-label">Select Shift</label>
                          <select
                            value={selectedShift}
                            name="ShiftId"
                            className="form-select"
                            style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                            onChange={(e) => {
                              setSelectedShift(e.target.value);
                            }}
                          >
                            <option value="">All</option>
                            {Array.isArray(shiftData) &&
                              shiftData.filter((shift) => shift.isActive).map((shift) => (
                                <option
                                  key={shift.shiftId}
                                  value={shift.shiftId}
                                  selected={shift.shiftId === selectedShift}
                                >
                                  {shift.shiftName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3 ">
                        <div className="form-group">
                          <label className="form-label">Select Route</label>
                          <select
                            value={selectedRoute}
                            name="RouteID"
                            className="form-select"
                            style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                            onChange={(e) => {
                              setSelectedRoute(e.target.value);
                            }}
                          >
                            <option value="">All</option>
                            {Array.isArray(routeData) &&
                              routeData.filter((route) => route.isActive).map((route) => (
                                <option
                                  key={route.routeId}
                                  value={route.routeId}
                                  selected={route.routeId === selectedRoute}
                                >
                                  {route.routeCode}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3 ">
                        <div className="form-group">
                          <label className="form-label">Select Owner</label>
                          <select
                            value={selectedOwner}
                            name="OwnerTypeId"
                            className="form-select"
                            style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                            onChange={(e) => {
                              setSelectedOwner(e.target.value);
                            }}
                          >
                            <option value="">All</option>
                            {Array.isArray(ownerData) &&
                              ownerData.filter((owner) => owner.isActive).map((owner) => (
                                <option
                                  key={owner.ownerTypeId}
                                  value={owner.ownerTypeId}
                                  selected={owner.ownerTypeId === selectedOwner}
                                >
                                  {owner.ownerTypeName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group"></div>
                        <button
                          type="button"
                          className={`btn mt-2 ${isProd ? "search-ghmc" : "search-swm"}`}
                          onClick={handleSearch}
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div></div>
          {isOptionsLoading && <Loader />}
          <div className="row mt-3" style={{ textAlign: "justify" }}>
            <div className="col-md-12">
              <div className="row scv-cards g-3" style={{ textAlign: "justify" }}>
                {Object.entries(gvpCountDashboard).map(
                  ([GVPDashboard, count]) => {
                    const displayName =
                      displayNames[GVPDashboard] || GVPDashboard;
                    return (

                      <div className="col-md-3">
                        <div className="card shadow">
                          <div className="card-body card_text_no">
                            <p className="card-title">{displayName}</p>
                            <h4 className="card-text">{count}</h4>
                          </div>
                        </div>
                      </div>

                    );
                  }
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3" >
          <div className="col-md-12 m-auto">
            <div className="card">
              <div className="card-header">
                Primary Deployment Dashboard Chart
              </div>
              <div className="card-body text-center">
                {chartData.length > 0 ? (
                  <PieChart width={800} height={450} className="mx-auto">
                    <Pie
                      data={chartData}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="50%"
                      outerRadius={150}
                      fill="#8884d8"
                      label
                    >
                      {chartData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                    <Tooltip />
                    <Legend />
                  </PieChart>
                ) : (
                  <p style={{ textAlign: "center", fontSize: "16px", fontWeight: "bold", }}>
                    No Preview available as data does not exists
                  </p>
                )}
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default ScvsDashboard;

const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};
